var React = require('react');

function HomeBottomWaveInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1440.13 142.025C1230.2 119.663 1174.59 245.234 1015.93 278.815C826.358 318.977 658.417 235.586 508.737 278.815C362.873 320.921 214.914 473.491 -1 411.267V0H1440L1440.13 142.025Z","fill":"#1C7775"}));
}

HomeBottomWaveInline.defaultProps = {"width":"1440","height":"426","viewBox":"0 0 1440 426","fill":"none"};

module.exports = HomeBottomWaveInline;

HomeBottomWaveInline.default = HomeBottomWaveInline;
